import {Component, inject, OnDestroy, OnInit} from '@angular/core';
import {ApiBaseService, VendorsService} from '../../../../../../projects/vendors/src/public-api';
import { ApiEnum } from '../../../../@application/enum/api.enum';
import { FoodItem } from '../../../../@domain/food-item';
import {Subscription} from "rxjs";

@Component({
    selector: 'app-highest-selling',
    templateUrl: './highest-selling.component.html',
    styleUrl: './highest-selling.component.scss',
    standalone: false
})
export class HighestSellingComponent implements OnInit, OnDestroy {

  heightSelling = [] as any[];
  apiBaseService = inject(ApiBaseService);
  vendorsService = inject(VendorsService);
  foodItems = [] as FoodItem[];
  orderCloseSubscription!: Subscription;

  ngOnInit(): void {
    this.dataSubscriptions();
    this.getFoodItem()
    this.getData();
  }

  private dataSubscriptions() {
    this.orderCloseSubscription = this.vendorsService.orderCloseSubject.subscribe({
      next: orderClose => {
        if (orderClose)
          this.getData();
      }
    })
  }

  isTabScreen(): boolean {
    return window.innerWidth <= 1000;
  }

  isMobileScreen(): boolean {
    return window.innerWidth <= 500;
  }


  private getData() {
    this.apiBaseService.GET<any[]>([ApiEnum.RestaurantModule,ApiEnum.Cart,ApiEnum.DashBoard,ApiEnum.TopSellingItems])
      .subscribe({
        next: response => {
          this.heightSelling = response.sort((a, b) => b.quantity - a.quantity);
        }
      })
  }

  getFoodItem(): void {
    this.apiBaseService.GET<FoodItem[]>([ApiEnum.FoodModule, ApiEnum.Food])
      .subscribe(res => {
        this.foodItems = res;
      });
  }

  ngOnDestroy(): void {
    this.orderCloseSubscription.unsubscribe();
  }


}
